import { areaSelectControl } from '../../../../../constants/form-control/client/area/area-select';
import { selectRequiredControl } from '../../../../../constants/form-control/core/common/select/select-required';
import { clientSelectControl, locationSelectControl } from '../../../../../constants/form-control/employee/assign-location';
import { SCHEDULE_MESSAGES } from '../../../../../constants/no-record-found/schedule';
import { FormControlUtil } from '../../../../../core/utils/form-control';
import { NoRecordFound, NoRecordType } from '../../../../../models/common/table/table-config';
import { MasterService } from '../../../../../state/master/services/master.service';

export const START_UNSCHEDULED_SHIFT_FORM_CONTROLS = {
  client_id: FormControlUtil.mergeFormControl(clientSelectControl, { key: 'client_id' }),
  location_id: FormControlUtil.mergeFormControl(locationSelectControl, {
    key: 'location_id', templateOptions: FormControlUtil.mergeFormControl(selectRequiredControl.templateOptions, {
      label: MasterService.masterBusinessLabel.Location,
      bindLabel: 'location_name',
      bindValue: 'location_id',
    }),
  }),
  area_id: FormControlUtil.mergeFormControl(areaSelectControl, { key: 'area_id' }),
};
export const noRecordFound: NoRecordFound = {
  type: NoRecordType.BASIC,
  title: SCHEDULE_MESSAGES.START_UNSCHEDULED_SHIFT_NO_RECORD_TITLE,
  message: '',
  show: true,
  iconSVG: 'assets/media/iq-svg/animation/schedule/start_unscheduled_shift.json',
}